// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Irh","badges":"styles_badges__3zZg7"};